import React from 'react';

import { GenericList } from 'modules/shared/components/generic-list';

import { LightProduct } from '../../../models';
import { ProductThumbnail } from '../../product/product-thumbnail';

import { HorizontalProductListProps } from './horizontal-product-list-type';

import styles from './horizontal-product-list-component.module.css';

export const HorizontalProductList: React.FC<HorizontalProductListProps> = React.memo(
    ({ products }: HorizontalProductListProps) => {
        return (
            <React.Fragment>
                <GenericList
                    items={products}
                    itemRenderer={(product: LightProduct) => {
                        return (
                            <div className={styles.ficheProductContainer} key={product.id}>
                                <ProductThumbnail product={product} />
                            </div>
                        );
                    }}
                />
            </React.Fragment>
        );
    },
);
